import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import AccountsEditor from "./AccountsEditor";

const AccountsEditorPage = () => {
  const { accountId } = useParams();
  const navigate = useNavigate();
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = accountId === "new";

  const createEmptyAccount = () => ({
    _id: crypto.randomUUID(),
    name: "New Account",
    type: "",
    party: "",
    journals: [{ id: "" }],

  });

  useEffect(() => {
    const fetchAccount = async () => {
      if (isNew) {
        setAccount(createEmptyAccount());
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://ledgers.poc.mrc.ai/api/accounts/${accountId}`);
          const data = await res.json();
          setAccount(data);
        } catch (error) {
          console.error("Error fetching Account:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchAccount();
  }, [accountId, isNew]);

  const handleSave = async (updatedAccount) => {
  try {
    const method = isNew ? "POST" : "PUT";
    const url = isNew
      ? `https://ledgers.poc.mrc.ai/api/accounts`
      : `https://ledgers.poc.mrc.ai/api/accounts/${accountId}`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedAccount),
    });

    if (!res.ok) throw new Error("Failed to save Account");

    const saved = await res.json();
    setAccount(saved);
  } catch (err) {
    console.error("Error saving Account:", err);
  }
};

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <AccountsEditor account={account} onClose={handleClose} isNew={isNew} />;
};

export default AccountsEditorPage;
